<template>
	<div class="capaddmeslc-wrap" style="padding:8px 15px 8px;background:#ededed" v-show="isHide">
		<div class="contentlc">
			<div class="title">
				<img src="/static/qmsj/img/icon1.jpg" alt=""><span class="titletext">基本信息</span>
			</div>
			<div class="evaluation-main">

				<el-row :gutter="0">
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">会员姓名：</span>
							<span class="maianListx">{{baseinfo.baobao_name}}</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">别名：</span>
							<span class="maianListx">{{baseinfo.baobao_name2}}</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">月龄：</span>
							<span class="maianListx">{{baseinfo.months}}月</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">性别：</span>
							<span class="maianListx">{{baseinfo.baobao_sex}}</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">生产：</span>
							<!--<span class="maianListx">{{baseinfo.answer1}}</span>-->
							<el-select v-model="baseinfo.answer1" size="mini" class="selectsty" placeholder="生产方式">
								<el-option label="顺产" value="顺产"></el-option>
								<el-option label="剖腹产" value="剖腹产"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">哺乳：</span>
							<el-select v-model="baseinfo.answer2" size="mini" class="selectsty" placeholder="哺乳方式">
								<el-option label="纯母乳" value="纯母乳"></el-option>
								<el-option label="纯奶粉" value="纯奶粉"></el-option>
								<el-option label="混合喂养" value="混合喂养"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">爸爸姓名：</span>
							<span class="maianListx">{{baseinfo.answer3}}</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">职业：</span>
							<el-select v-model="baseinfo.answer4" size="mini" class="selectsty" placeholder="职业">
								<el-option label="公职人员" value="公职人员"></el-option>
								<el-option label="老师" value="老师"></el-option>
								<el-option label="企业管理人员" value="企业管理人员"></el-option>
								<el-option label="企业员工" value="企业员工"></el-option>
								<el-option label="个体户" value="个体户"></el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">年龄：</span>
							<span class="maianListx">
								<el-input-number class="jishuqi" v-model="baseinfo.answer5" :min="1"></el-input-number>岁
							</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">性格：</span>
							<el-select v-model="baseinfo.answer6" size="mini" class="selectsty" placeholder="性格">
								<el-option label="开朗" value="开朗"></el-option>
								<el-option label="内向" value="内向"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
							<span class="maianListCatalog">在家：</span>
							<el-select v-model="baseinfo.answer7" size="mini" class="selectsty" placeholder="在家时间">
								<el-option label="全职" value="全职"></el-option>
								<el-option label="晚上" value="晚上"></el-option>
								<el-option label="周末" value="周末"></el-option>
								<el-option label="不多" value="不多"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">互动：</span>
							<el-select v-model="baseinfo.answer8" size="mini" class="selectsty" placeholder="互动">
								<el-option label="经常" value="经常"></el-option>
								<el-option label="不多" value="不多"></el-option>
								<el-option label="偶尔" value="偶尔"></el-option>
								<el-option label="没有" value="没有"></el-option>
							</el-select>
						</div>
					</el-col>

					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">妈妈姓名：</span><span class="maianListx">{{baseinfo.answer9}}</span>
						</div>
					</el-col>

					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">职业：</span>
							<el-select v-model="baseinfo.answer10" size="mini" class="selectsty" placeholder="职业">
								<el-option label="公职人员" value="公职人员"></el-option>
								<el-option label="老师" value="老师"></el-option>
								<el-option label="企业管理人员" value="企业管理人员"></el-option>
								<el-option label="企业员工" value="企业员工"></el-option>
								<el-option label="个体户" value="个体户"></el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">年龄：</span><span class="maianListx">
								<el-input-number class="jishuqi" v-model="baseinfo.answer11" :min="1"></el-input-number>
								岁
							</span>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">性格：</span>
							<el-select v-model="baseinfo.answer12" size="mini" class="selectsty" placeholder="性格">
								<el-option label="开朗" value="开朗"></el-option>
								<el-option label="内向" value="内向"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">在家：</span>
							<el-select v-model="baseinfo.answer13" size="mini" class="selectsty" placeholder="在家时间">
								<el-option label="全职" value="全职"></el-option>
								<el-option label="晚上" value="晚上"></el-option>
								<el-option label="周末" value="周末"></el-option>
								<el-option label="不多" value="不多"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">互动：</span>
							<el-select v-model="baseinfo.answer14" size="mini" class="selectsty" placeholder="互动">
								<el-option label="经常" value="经常"></el-option>
								<el-option label="不多" value="不多"></el-option>
								<el-option label="偶尔" value="偶尔"></el-option>
								<el-option label="没有" value="没有"></el-option>
							</el-select>
						</div>
					</el-col>

					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">爬行时间：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer15" :min="1"></el-input-number>个月
							</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">走路时间：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer16" :min="1"></el-input-number>个月
							</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">辅食添加：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer17" :min="1"></el-input-number>个月
							</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">断奶时间：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer18" :min="1"></el-input-number>个月
							</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">开口说话：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer19" :min="1"></el-input-number> 个月
							</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="maianList">
							<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">会叫人时间：</span><span class="maianListx">第
								<el-input-number class="jishuqi" v-model="baseinfo.answer20" :min="1"></el-input-number> 个月
							</span>
						</div>
					</el-col>

				</el-row>

			</div>

		</div>


		<div class="contentlc" style="margin-top: 10px">
			<div class="title" style="margin-bottom: 20px">
				<img src="/static/qmsj/img/icon2.jpg" alt=""><span class="titletext">宝宝成长测评</span>
			</div>
			<div class="evaluation-main">

				<div class="listmsg" style="margin-top: 10px">
					<el-row :gutter="0">
						<el-col :span="24">
							<div class="maianList text-center">宝宝身体信息</div>
						</el-col>

						<el-col :span="5" v-for="(item,indexitem1) in leveldata[1][1]" :key="indexitem1">
							<div class="maianList" v-if="item.html_type=='计数器'">
								<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{item.question}}：</span>
								<span class="maianListx">
									<el-input-number class="jishuqi" v-model="item.answer" :min="1"></el-input-number>
									{{item.suffix}}
								</span>
							</div>
							<div class="maianList" v-if="item.html_type=='单选框'">
								<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{item.question}}：</span>
								<span class="maianListx">
									<el-select v-model="item.answer" size="mini" class="selectsty" placeholder="请选择">
										<el-option :label="itemm2" :value="indexm2+1" :key="indexm2" v-for="(itemm2,indexm2) in item.options"></el-option>
									</el-select>
								</span>
							</div>
						</el-col>

						<el-col :span="12" v-for="(item,indexitemel2) in leveldata[1][2]" :key="indexitemel2">
							<!--v-if="msg1.html_type=='计数器'" -->
							<div class="maianList">

								<img class="circle" src="/static/qmsj/img/circle1.png" alt="">
								<span class="maianListCatalog">{{item.question}}：</span>
								<span class="maianListx">
									<el-checkbox-group v-model="item.answer" style="display: inline-block">
										<el-checkbox :label="indexs+1" v-for="(xuan,indexs) in item.options" :key="indexs">{{xuan}}</el-checkbox>
									</el-checkbox-group>
								</span>
							</div>
						</el-col>


						<!--<el-col :span="12"   v-for="(item,index) in msg1" v-if="msg1.html_type=='多选框'" >-->
						<!--&lt;!&ndash;v-if="msg1.html_type=='计数器'" &ndash;&gt;-->
						<!--<div class="maianList" >-->
						<!--<img class="circle" src="/static/qmsj/img/circle1.png" alt=""><span class="maianListCatalog">{{item.question}}：</span>-->
						<!--<span class="maianListx" >-->
						<!--<el-checkbox-group v-model="checkList" style="display: inline-block">-->
						<!--<el-checkbox label="复选框 A" v-for=" msg1d.options"></el-checkbox>-->
						<!--<el-checkbox label="复选框 B"></el-checkbox>-->
						<!--</el-checkbox-group>-->
						<!--</span>-->
						<!--</div>-->
						<!--</el-col>-->
						<!--</span>-->

					</el-row>
				</div>

				<div class="listmsg" style="margin-top: 10px">
					<el-row :gutter="0">
						<el-col :span="24">
							<div class="maianList text-center">宝宝成长过程中遇到的状况</div>
						</el-col>

						<el-col :span="24" clss="baobaoczz">
							<el-checkbox-group v-model="leveldata[2][0].answer" style="display: inline-block">
								<el-checkbox :label="indea+1" style="margin-left: 0;margin-right: 30px;margin-bottom: 10px" v-for="(yuzhuang,indea) in leveldata[2][0].options" :key="indea">{{yuzhuang}}
								</el-checkbox>
							</el-checkbox-group>
						</el-col>
					</el-row>
				</div>

				<div class="listmsg" style="margin-top: 10px">
					<el-row :gutter="0">
						<el-col :span="24">
							<div class="maianList text-center">家庭养人及主要教养方式</div>
						</el-col>
						<span>
							<el-col :span="24" v-for="(jiao,jiaoindex3) in leveldata[3]" :key="jiaoindex3">
								<div class="maianList">
									<span class="maianListCatalog">{{jiao.question}}：</span>
									<el-radio @change="radio1_status = true" v-model="jiao.answer" :label="indexc+1" v-for="(jiaoyu,indexc) in jiao.options" :key="'radio'+indexc">{{jiaoyu}}</el-radio>
								</div>
							</el-col>
						</span>
					</el-row>
				</div>

				<div class="listmsg" style="margin-top: 10px">
					<el-row :gutter="0">
						<el-col :span="24">
							<div class="maianList text-center">家长教养知识状况</div>
						</el-col>
						<span>
							<span v-for="(zhuang,index) in leveldata[4]">
								<el-col :span="20">
									<div class="maianList">
										<span class="maianListCatalog">{{index+1}}、{{zhuang.question}}</span>
									</div>
								</el-col>
								<el-col :span="4">
									<div class="maianList" style="overflow: hidden">
										<el-radio @change="radio2_status = true" v-model="zhuang.answer" :label="indexa+1" v-for="(pan,indexa) in zhuang.options" :key="'rad'+indexa">{{pan}}</el-radio>
									</div>
								</el-col>
							</span>
						</span>
					</el-row>
				</div>

				<div class="huiBtn zi" style="width: 90px;margin: 30px auto" @click="updata">确定</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				iid: '',
				baseinfo: {
					answer1: "",
					answer2: "",
					answer3: "",
					answer4: "",
					answer5: 1,
					answer6: "",
					answer7: "",
					answer8: "",
					answer9: "",
					answer10: "",
					answer11: 1,
					answer12: "",
					answer13: "",
					answer14: "",
					answer15: 1,
					answer16: 1,
					answer17: 1,
					answer18: 1,
					answer19: 1,
					answer20: 1
				},
				leveldata: [
					[],
					[{}, {
						'answer': ''
					}, {}, {
						'answer': ''
					}],
					[{}, {
						'answer': ''
					}],
					[],
					[]
				],
				create: '',
				token: '',
				radio1_status:false,
				radio2_status:false,
				isHide:true,
			}
		},
		filters: {
			typename: function(value) {
				if (value == 1) return "专家测评"
				if (value == 2) return "家长测评"
			}
		},
		methods: {
			updata: function() {
				let self = this;
				if(self.leveldata[2][0].answer != '' && self.radio1_status != false && self.radio2_status != false){
					$.ajax({
						url: process.env.apiUrl + `saas/ceping/cp_query_store`,
						type: "post",
						dataType: "json",
						data: {
							token: self.token,
							baseinfo: self.baseinfo,
							leveldata: self.leveldata
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									message: data.msg,
									type: 'success',
									duration: 1000
								});
								setTimeout(function() {
									self.$router.push({
										name: 'yinxiaolie'
									})
								}, 1000)
							} else {
								self.$message({
									message: data.msg,
									type: 'error',
									duration: 1000
								});
							}
						}
					})
				}else{
					self.$message({
						message: '请先完善宝宝成长测评',
						type: 'error',
						duration: 1000
					});
				}

			}
		},
		mounted: function() {
			this.iid = this.$route.query.iid;
			this.token = $.cookie('token')
			let self = this;
			$.ajax({
				url: process.env.apiUrl + `saas/ceping/cp_query_index`,
				type: "post",
				dataType: "json",
				data: {
					id: self.iid,
					token: self.token
				},
				success: function(data) {
					if (data.status == 1) {
						self.baseinfo = data.baseinfo;
						self.leveldata = data.leveldata;
					} else {
						self.isHide = false
						self.$message.error({
							message:data.msg,
						});
						setTimeout(()=>{
							self.$router.go(-1)
						},2000)
					}
				}
			});
		}
	}
</script>
<style lang="less">
	.capaddmeslc-wrap {
		.contentlc .el-input-number .el-input__inner {
			padding-left: 0px;
			padding-right: 0px;
		}
		.maianList .el-input__inner {
			width: 83px;
			padding-left: 5px;
			padding-right: 20px;
		}

		.jishuqi.el-input-number {
			width: 70px;
			border: none;
		}

		.jishuqi .el-input-number__decrease,
		.jishuqi .el-input-number__increase {
			width: 16px;
			height: 16px;
			border-radius: 8px;
			background: #fff;
			border: 1px solid #E6BE8A;
			top: 12px;
		}

		.jishuqi .el-icon-plus,
		.jishuqi .el-icon-minus {
			vertical-align: top;
			font-size: 10px;
			padding: 2px 2px 0 1px;
			color: #000;
		}

		.jishuqi .el-input__inner {
			padding-left: 20px;
			padding-right: 20px;
			width: 70px;
			border: none;
		}

		.maianList .el-radio+.el-radio {
			margin-left: 10px;
		}

		.baobaoczz .el-checkbox-group .el-checkbox+ {
			margin-left: 30px;
		}
	}
</style>
<style scoped>
	[v-cloak] {
		display: none;
	}

	body {
		color: #666;
		font-size: 16px;
	}

	.contentlc {
		background: #fff;
		padding: 10px;
		border-radius: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

	.title {
		font-size: 20px;
		line-height: 30px;
		height: 30px;
	}

	.title img {
		width: 30px;
		vertical-align: middle;
	}

	.titletext {
		padding-left: 20px;
	}

	.evaluation-main {
		padding-left: 10px;
	}

	.maianList {
		height: 34px;
		line-height: 34px;
	}

	.circle {
		width: 6px;
		vertical-align: middle;
	}

	.maianListCatalog {
		padding-left: 3px;
	}

	.maianListx {
		color: #000;
	}

	.listmsg {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
		padding: 20px 0 20px 20px;
		border-radius: 10px;
	}

	.xuanz {
		width: 16px;
		margin-left: 5px;
		vertical-align: middle;
		margin-top: -5px;
	}

	.huiBtn {
		padding: 3px 20px;
		border-radius: 18px;
		cursor: pointer;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		text-align: center;
		font-size: 16px;
	}

	.huiBtn.zi {
		background: #E6BE8A;
		color: #fff;
	}
</style>




// WEBPACK FOOTER //
// src/pages/ceping/cpaddmeslc.vue